import { useTranslation } from 'react-i18next';

import { Form, Field, TextField } from 'libs/form';
import { Button, Buttons } from 'libs/ui';
import { validationSchema } from './login-form.validation';

export const LoginForm = (props) => {
  const { t } = useTranslation();
  const initial = {
    username: '',
    password: '',
  };

  return (
    <Form initialValues={initial} validationSchema={validationSchema(t)} onSubmit={props.onSubmit}>
      <Field name="username" label={t('forms.Логин')} component={TextField} />
      <Field name="password" label={t('forms.Пароль')} component={TextField} type="password" />

      <Buttons>
        <Button fullWidth type="submit">
          {t('forms.Войти')}
        </Button>
      </Buttons>
    </Form>
  );
};
